<template>
  <billing-report-panel
    report-key="batches-open"
    route="/reports/billing-batches-open"
    file-name="lotes-em-aberto.xlsx"
    period-label="Período de envio do lote"
    :columns="columns"
    :default-days="180"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Lote',
        'Convênio',
        'Protocolo',
        'Enviado em',
        'Dias desde o envio',
        'Faixa de envelhecimento',
        'Previsão de recebimento',
        'Valor parado',
        'Subtotal por faixa',
      ],
    };
  },
};
</script>
